import type { StaticImageData } from "next/image";
import { Images } from "@assets/assets";

export interface AwardItem {
  name: string;
  image: string | StaticImageData;
}

export const data: AwardItem[] = [
  { name: "Clutch", image: Images?.award1 },
  { name: "Top rated", image: Images?.award2 },
  { name: "UpFirms", image: Images?.award3 },
  { name: "Leaders", image: Images?.award4 },
  { name: "ITFirms", image: Images?.award5 },
  { name: "Top developers", image: Images?.award6 },
];
